// Bluesky API URL
export const BLUESKY_API_URL = 'https://public.api.bsky.app'

// Routes
export const ACTOR_STARTER_PACKS_ROUTE =
  '/xrpc/app.bsky.graph.getActorStarterPacks'
export const PROFILE_ROUTE = '/xrpc/app.bsky.actor.getProfile'
export const FOLLOWERS_ROUTE = '/xrpc/app.bsky.graph.getFollowers'
export const FOLLOWS_ROUTE = '/xrpc/app.bsky.graph.getFollows'
export const LIST_ROUTE = '/xrpc/app.bsky.graph.getList'
export const RESOLVE_HANDLE_ROUTE = '/xrpc/com.atproto.identity.resolveHandle'
export const STARTER_PACK_ROUTE = '/xrpc/app.bsky.graph.getStarterPack'
export const SEARCH_ACTORS_ROUTE = '/xrpc/app.bsky.actor.searchActors'

// Mutation Routes
export const FOLLOW_ROUTE = '/follow'
export const UNFOLLOW_ROUTE = '/unfollow'
